export enum RatingUnit {
  MVA = "MVA",
  kVA = "kVA"
}